import createSelector from 'lib/web/createSelector'
import { isBedbankItem, isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import { getAccommodationItems } from './view/accommodation'
import { getFlightItems } from './view/flights'

export const isFlightsPendingToAddToCart = createSelector(
  getFlightItems,
  (flightItems) : boolean => {
    return flightItems.length > 0 &&
    flightItems.some(item => {
      if (item.fareType === 'return') {
        return !item.departing || !item.returning
      } else if (item.fareType === 'oneWay') {
        return !item.departing
      }
    })
  },
)

export const isExperiencesSupportedToAddToCart = createSelector(
  getAccommodationItems,
  (state: App.State) => state.checkout.cart.postPurchase,
  (accommodationItems, postPurchase) : boolean =>
    accommodationItems.length > 0 &&
    accommodationItems.every(item => isInstantBookingLEHotelItem(item) || isBedbankItem(item)) &&
    (!postPurchase || postPurchase === 'select-date'),
)
